import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play-2",
  "use": "play-2-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 12\" id=\"play-2\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.544 11.884l8.49-5.513c.262-.17.29-.467.06-.662a.582.582 0 00-.058-.044L1.546.117C1.283-.054.885-.035.655.16A.408.408 0 00.5.469V11.53c0 .26.282.469.63.469.152 0 .3-.041.414-.116z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol